// @ts-strict-ignore
import { getNumericPathIndices } from '~/dashboard/views/workflows/service/actions';
import { createStringOfPathArray } from '~/dashboard/views/workflows/store/engine/utils';
import { CaretPositionSuffixTypes, RuleEditorDropdownMode } from '../../NodeEditorDrawer/types';
import { getParentRulePathIndicies } from '../../thresholds/RuleLinesContainer/helpers';
import { getProperty } from 'dot-prop';
import { populateDataRouteData } from '~/dashboard/views/workflows/service/dataRoutes';
import type {
  Action, DataRoute, Expression, ServicesByName,
} from '~/dashboard/views/workflows/store/engine/types';

export const getExpressionPathInDotNotationFormat = ({
  expressions,
  itemFlatCaret,
  workflowInfo: { actions, dataRoutes, services },
}: {
  expressions: Expression;
  itemFlatCaret: any;
  workflowInfo: {
    actions: Record<string, Action>;
    dataRoutes: Record<string, DataRoute>;
    services: ServicesByName;
  };
}) => {
  const pathIndices = getNumericPathIndices(itemFlatCaret, 'expressions');
  if (!pathIndices) return undefined;

  const path = createStringOfPathArray(pathIndices);

  const groupingsMap = {
    [CaretPositionSuffixTypes.GROUP_START]: RuleEditorDropdownMode.GROUP_START,
    [CaretPositionSuffixTypes.GROUP_START_PENDING]: RuleEditorDropdownMode.GROUP_START_PENDING,
    [CaretPositionSuffixTypes.GROUP_END]: RuleEditorDropdownMode.GROUP_END,
  };

  for (const [caretSuffix, mode] of Object.entries(groupingsMap)) {
    if (itemFlatCaret.endsWith(caretSuffix)) {
      return {
        path,
        type: mode,
        data: undefined,
      };
    }
  }

  if (itemFlatCaret.endsWith(CaretPositionSuffixTypes.DATAROUTE)) {
    const parentPathIndicies = getParentRulePathIndicies(pathIndices);
    const parentPathString = createStringOfPathArray(parentPathIndicies);
    const parentData = getProperty(expressions, parentPathString, { data_route_id: null });

    if (parentData.data_route_id) {
      const extendedDataRoute = populateDataRouteData({
        actions, services, dataRoute: dataRoutes[parentData.data_route_id],
      });

      const pathIndicesMap = {
        0: RuleEditorDropdownMode.DATAROUTE_SOURCE,
        1: RuleEditorDropdownMode.DATAROUTE_ATTRIBUTE,
      };

      return {
        path: parentPathString,
        type: pathIndicesMap[pathIndices.at(-1)] || RuleEditorDropdownMode.EXPRESSION,
        data: extendedDataRoute,
      };
    }

    return {
      path,
      type: RuleEditorDropdownMode.EXPRESSION,
      data: parentData,
    };
  }

  return {
    path,
    type: RuleEditorDropdownMode.EXPRESSION,
    data: getProperty(expressions, path, undefined),
  };
};
